import {React, useState, useEffect, useCallback } from "react";
import MuiTable from "../common/MuiTable";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { UI_5_3_tableRow } from "./helper/UI_5_3.helper";
import { FxOpenButton } from "../../fxms/inputs/FxOpenButton";

/*관리자> 가입승인*/
export const UI_5_3 = (props) => {
  const opObjCheck = FxmsData.getOpObj("ui-5-3-edit");
  const [tableRenderKey, setTableRenderKey] = useState(0);
  const [selected, setSelected] = useState({
    processStCd: "ALL",

  });   
  const [fetchData, setFetchData] = useState([]);

    useEffect(() => {
      submitBtnClick();
    }, []);

  const submitBtnClick = useCallback(async () => {
    const param = {
      newUsrRegStCd: selected.processStCd,
    }

    try {
      const uri = "vup/select_5_3";
      const res = await FxmsData.GET(uri, param);

      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      setFetchData(res.data);
    } catch (e) {
      console.log("UI_5_3 fetchData error", e);
    }
  }, [selected]);

  const dataGrid = (
    regDtm,         // 신청일시
    applyUserId,    // 신청사용자ID
    applyUserName,  // 신청사용자명
    applyTelNo,     // 신청전화번호
    applyUserMail,  // 신청메일
    applyMemo,      // 신청메모
    procUserName,   // 처리사용자명
    procDtm,        // 처리일시
    procRsn,        // 처리사유
    newUserRegStCd, // 신규사용자통계사업코드
    stCd            // 상태 코드
) => {
    return {
        regDtm,
        applyUserId,
        applyUserName,
        applyTelNo,
        applyUserMail,
        applyMemo,
        procUserName,
        procDtm,
        procRsn,
        newUserRegStCd,
        stCd
    };
};

const formatDateTime = (dateTimeStr) => {
  // null, undefined, 빈 문자열 체크
  if (!dateTimeStr) return '-';
  
  // 문자열로 변환
  const strDateTime = String(dateTimeStr);
  
  // 길이가 14자리가 아닌 경우 원본 반환
  if (strDateTime.length !== 14) return dateTimeStr;

  try {
    return `${strDateTime.substring(0,4)}-${strDateTime.substring(4,6)}-${strDateTime.substring(6,8)} ${strDateTime.substring(8,10)}:${strDateTime.substring(10,12)}:${strDateTime.substring(12,14)}`;
  } catch (e) {
    console.log('날짜 포맷팅 에러:', e);
    return dateTimeStr; // 에러 발생 시 원본 반환
  }
}

const resultRow = fetchData.map(item => {
    return dataGrid(
        formatDateTime(item.regDtm),
        item.applyUserId,
        item.applyUserName,
        item.applyTelNo,
        item.applyUserMail,
        item.applyMemo,
        item.procUserName,
        formatDateTime(item.procDtm),
        item.procRsn,
        item.newUserRegStCd,
        item.stCd === 'S' ? 
        <FxOpenButton    // 상세보기 버튼 추가
            key={`${item.applyUserId}-${item.applyUserName}`}  // key prop 추가
            title={"승인/반려"}
            opObj={opObjCheck}
            selectedData={item}
            className="fpactButton"
            refershGridData={submitBtnClick}
        /> : '처리 완료'
    )
});

  const handleSelectData = (event) => {
    const { id, value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })    
  }

  const onClickSearch = () => {
    // 조회 시 페이지를 1페이지로 초기화
    setTableRenderKey((prev) => prev + 1);
    submitBtnClick();
  };

  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>        
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="processStCd" value={selected.processStCd} onChange={handleSelectData}>
            <option value="ALL">처리상태 전체</option>
            <option value="S">대기</option>
            <option value="A">승인</option>
            <option value="R">반려</option>
          </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxButtonSearch" type="button" value="조회" onClick={onClickSearch}/>
        </div>
      </div>
      <div className="FxCrudDataGrid">     
        <div className="FxMuiTable">
          <MuiTable
            key={tableRenderKey}
            tableRowDataList={UI_5_3_tableRow}
            rows={resultRow}
            menuFullName='관리자/가입승인'
          />
        </div>
      </div>
    </div>
    </>
  )

}
